import { 
  ChatBubbleOvalLeftEllipsisIcon, 
  CursorArrowRaysIcon, 
  DocumentCheckIcon, 
  FingerPrintIcon,
  MoonIcon,
  PresentationChartBarIcon, 
  SunIcon,
  UserCircleIcon 
} from "@heroicons/react/24/outline"

import { authService } from "@services"
import { hasRight, getSbUrl } from "@helpers"

export const getLinks = (currentTheme, setTheme, is365) => {
  const themeIcon = currentTheme === 'dark' 
    ? <SunIcon className="text-content2-foreground size-7 group-hover:text-foreground" /> 
    : <MoonIcon className="text-content2-foreground size-7 group-hover:text-foreground" />

  const links = [
    {
      "id": "my-profile",
      "icon": <UserCircleIcon className="text-content2-foreground size-7 group-hover:text-foreground" />,
      "title": "My Profile",
      "description": "Update your profile.",
      "href": getSbUrl("/apps/bookings/myprofile.php"),
      "show": true,
      "openInNewTab": false,
      "isSelected": false
    },
    {
      "id": "theme",
      "icon": themeIcon,
      "title": "Theme",
      "description": "Switch between light and dark.",
      "href": '#',
      "show": true,
      "openInNewTab": false,
      "onClick": () => setTheme(currentTheme === 'dark' ? 'light' : 'dark'),
      "isSelected": false
    },
    {
      "id": "bookings",
      "icon": <svg className="text-content2-foreground size-7 group-hover:text-foreground" viewBox="0 0 64 64" fill="currentColor"><g><path d="M20.5,36.6h-3.1c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3.1c0.6,0,1-0.4,1-1v-3C21.5,37.1,21,36.6,20.5,36.6z"/><path d="M33.5,36.6h-3.1c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3.1c0.6,0,1-0.4,1-1v-3C34.5,37.1,34.1,36.6,33.5,36.6z"/><path d="M46.6,36.6h-3.1c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3.1c0.6,0,1-0.4,1-1v-3C47.6,37.1,47.2,36.6,46.6,36.6z"/><path d="M20.5,49.5h-3.1c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3.1c0.6,0,1-0.4,1-1v-3C21.5,50,21,49.5,20.5,49.5z"/><path d="M33.5,49.5h-3.1c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3.1c0.6,0,1-0.4,1-1v-3C34.5,50,34.1,49.5,33.5,49.5z"/><path d="M46.6,49.5h-3.1c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h3.1c0.6,0,1-0.4,1-1v-3C47.6,50,47.2,49.5,46.6,49.5z"/><path d="M56,15.4H34.3v-1.9c2.3-0.9,3.9-3.1,3.9-5.7c0-3.4-2.8-6.1-6.2-6.1s-6.2,2.7-6.2,6.1c0,2.6,1.6,4.8,3.9,5.7v1.9H8 c-3.4,0-6.3,2.8-6.3,6.3V56c0,3.4,2.8,6.3,6.3,6.3h48c3.4,0,6.3-2.8,6.3-6.3V21.6C62.3,18.2,59.4,15.4,56,15.4z M32,6.2 c0.9,0,1.7,0.7,1.7,1.6c0,0.9-0.7,1.6-1.7,1.6s-1.7-0.7-1.7-1.6C30.3,6.9,31.1,6.2,32,6.2z M8,19.9h48c1,0,1.8,0.8,1.8,1.8v6.2H6.3 v-6.2C6.3,20.6,7,19.9,8,19.9z M56,57.8H8c-1,0-1.8-0.8-1.8-1.8V32.3h51.5V56C57.8,57,57,57.8,56,57.8z"/></g></svg>,
      "title": "Bookings",
      "description": "Manage room & resource bookings.",
      "href": getSbUrl("/apps/bookings"),
      "show": hasRight("bookings"),
      "openInNewTab": false,
      "isSelected": false
    },
    {
      "id": "lettings",
      "icon": <svg viewBox="0 0 64 64" className="text-content2-foreground size-7 group-hover:text-foreground" fill="currentColor"><g><path d="M56,1.8H33.5c-3.4,0-6.2,2.8-6.2,6.3v3.9H8c-3.4,0-6.3,2.8-6.3,6.3V56c0,3.4,2.8,6.3,6.3,6.3h48c3.4,0,6.3-2.8,6.3-6.3V8 C62.3,4.6,59.4,1.8,56,1.8z M27.2,57.8H8c-1,0-1.8-0.8-1.8-1.8V18.2c0-1,0.8-1.8,1.8-1.8h19.2V57.8z M57.8,56c0,1-0.8,1.8-1.8,1.8 H31.7V8c0-1,0.8-1.8,1.7-1.8H56c1,0,1.8,0.8,1.8,1.8V56z"/><path d="M14,28.1h5.6c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3H14c-1.2,0-2.3,1-2.3,2.3S12.8,28.1,14,28.1z"/><path d="M14,39.3h5.6c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3H14c-1.2,0-2.3,1-2.3,2.3S12.8,39.3,14,39.3z"/><path d="M13.9,50.6h5.6c1.2,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3h-5.6c-1.2,0-2.3,1-2.3,2.3S12.7,50.6,13.9,50.6z"/><path d="M47.6,14.7H42c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3h5.6c1.2,0,2.3-1,2.3-2.3S48.8,14.7,47.6,14.7z"/><path d="M47.6,29.1H42c-1.2,0-2.3,1-2.3,2.3c0,1.2,1,2.3,2.3,2.3h5.6c1.2,0,2.3-1,2.3-2.3C49.8,30.1,48.8,29.1,47.6,29.1z"/><path d="M47.5,43.5h-5.6c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3h5.6c1.2,0,2.3-1,2.3-2.3S48.7,43.5,47.5,43.5z"/></g></svg>,
      "title": "Lettings",
      "description": "Manage your lettings.",
      "href": getSbUrl("/apps/let"),
      "show": hasRight("lettings"),
      "openInNewTab": false,
      "isSelected": false
    },
    {
      "id": "parents",
      "icon": <svg className="text-foreground size-8" fill="currentColor" viewBox="0 0 64 64"><g><path d="M21.8,36.8c6.9,0,12.4-5.6,12.4-12.4s-5.6-12.4-12.4-12.4S9.4,17.5,9.4,24.4S15,36.8,21.8,36.8z M21.8,16.4 c4.4,0,7.9,3.6,7.9,7.9s-3.6,7.9-7.9,7.9c-4.4,0-7.9-3.6-7.9-7.9S17.4,16.4,21.8,16.4z"/><path d="M21.8,39.9c-7.2,0-14.1,2.9-19.4,8.3c-0.9,0.9-0.9,2.3,0,3.2c0.4,0.4,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7 c4.4-4.5,10.2-7,16.2-7c5.9,0,11.7,2.5,16.2,7c0.9,0.9,2.3,0.9,3.2,0c0.9-0.9,0.9-2.3,0-3.2C35.9,42.9,29,39.9,21.8,39.9z"/><path d="M47.3,36.8c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3C39.9,33.5,43.2,36.8,47.3,36.8z M47.3,26.6 c1.6,0,2.8,1.3,2.8,2.8c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8C44.4,27.9,45.7,26.6,47.3,26.6z"/><path d="M61.5,45.6c-5.3-4.9-12.6-6.9-19.9-5c-1.2,0.3-1.9,1.5-1.6,2.7c0.3,1.2,1.6,1.9,2.7,1.6c5.8-1.5,11.6,0,15.7,3.9 c0.4,0.4,1,0.6,1.5,0.6c0.6,0,1.2-0.2,1.6-0.7C62.5,47.9,62.4,46.5,61.5,45.6z"/></g></svg>,
      "title": "Parents",
      "description": "Organise parent-teacher meetings.",
      "href": null,
      "show": true,
      "openInNewTab": false,
      "isSelected": true
    },
    {
      "id": "administration",
      "icon": <CursorArrowRaysIcon className="text-content2-foreground size-7 group-hover:text-foreground" />,
      "title": "Administration",
      "description": "Global settings and configuration.",
      "href": getSbUrl("/apps/administration"),
      "show": hasRight("admin"),
      "openInNewTab": false,
      "isSelected": false
    },
    {
      "id": "reports",
      "icon": <PresentationChartBarIcon className="text-content2-foreground size-7 group-hover:text-foreground" />,
      "title": "Reports",
      "description": "Statistics and reports.",
      "href": getSbUrl("/apps/reports"),
      "show": hasRight("reports"),
      "openInNewTab": false,
      "isSelected": false
    },
    {
      "id": "support",
      "icon": <ChatBubbleOvalLeftEllipsisIcon className="text-content2-foreground size-7 group-hover:text-foreground" />,
      "title": "Support",
      "description": hasRight("admin") ? "Guides / Tickets / Contact us" : "User guides and support articles.",
      "href": hasRight("admin") ? getSbUrl("/apps/administration/support.php") : "https://help.schoolbooking.com/category/parent-meetings/parent-meeting-articles-for-teachers",
      "show": true,
      "openInNewTab": hasRight("admin") ? false : true,
      "isSelected": false
    },
    { 
      "id": "licence",
      "icon": <DocumentCheckIcon className="text-content2-foreground size-7 group-hover:text-foreground" />,
      "title": "Licence",
      "description": "View your licence details.",
      "href": getSbUrl("/apps/administration/licence/licence.php"),
      "show": hasRight("admin"),
      "openInNewTab": false,
      "isSelected": false
    },
    {
      "id": "sign-out",
      "icon": <FingerPrintIcon className="text-content2-foreground size-7 group-hover:text-foreground" />,
      "title": "Sign out",
      "description": is365 ? "Logout of Office 365" : "Logout of School Booking",
      "href": "#",
      "onClick": () => authService.logout(getSbUrl("/apps/shared/signout.php")),
      "show": true,
      "openInNewTab": false,
      "isSelected": false
    }
  ]

  return links.filter(link => link.show)
}